import { call, put, takeLatest } from 'redux-saga/effects';
import { setSelectedProductUpdate } from 'src/actions/QueryProductUpdateAction';

import {
  getAdditionalInfoQuerySuccessAction,
  getSelectedProductQueryFailedAction,
  SELECTED_PRODUCT_QUERY_START,
  SelectedProductQueryStartAction,
  getSelectedProductQueryUpdatingAction,
} from 'src/actions/SelectedProductQueryAction';
import SearchType, { SelectedProductResponse } from 'src/model/ProductMatch';
import QueryProductInfo from 'src/model/QueryProduct';
import {
  getCurrencyUnitConfig,
  isLoginMode,
  isWidget,
} from 'src/config/Config';
import ProductDataValidator from 'src/utils/ProductDataValidator';
import ApiUtil from 'src/utils/ApiUtil';
import MetricsUtil from 'src/utils/MetricsUtil';

export function* getSelectedProductData(
  action: SelectedProductQueryStartAction,
) {
  try {
    const metricsUtil = MetricsUtil.getMetricsUtil();
    metricsUtil.publishString('searchedASIN', action.selectedProduct.asin);

    const response: SelectedProductResponse = {
      countryCode: action.countryCode,
      selectedProduct: action.selectedProduct,
    };
    yield put(getSelectedProductQueryUpdatingAction(response));

    const product = action.selectedProduct;
    const parameters: any = {
      countryCode: action.countryCode,
      asin: action.selectedProduct.asin,
      fnsku: action.selectedProduct.fnsku,
      searchType: action.selectedProduct.isMyProduct
        ? SearchType.MERCHANT
        : SearchType.GENERAL,
    };
    // @ts-expect-error
    const additionalInfoRes = yield call(
      ApiUtil.callApiWithTimeout,
      'getadditionalpronductinfo',
      parameters,
    );
    //if no featured offer, result is {"succeed":true,"data":null}
    const additionalInfo = additionalInfoRes?.data;

    if (
      !isLoginMode() ||
      isWidget() ||
      ProductDataValidator.isProductAndAdditionalInfoValid(
        product,
        additionalInfo,
      )
    ) {
      const featuredOfferPrice: number = additionalInfo?.price?.amount;
      const featuredOfferShipping: number = additionalInfo?.shipping?.amount;
      const featuredOfferCurrency: string = additionalInfo?.price?.currency;
      // We use merchant's price for fee estimation if available
      const price =
        product.price && product.price > 0 ? product.price : featuredOfferPrice;
      const currency =
        product.price && product.price > 0
          ? product.currency
          : featuredOfferCurrency;
      // We use dimension and weight from additional info if available (potential FWD for my products)
      let length = 0;
      let width = 0;
      let height = 0;
      let dimensionUnit = '';
      let weight = 0;
      let weightUnit = '';
      if (isLoginMode()) {
        length =
          additionalInfo?.length > 0 ? additionalInfo.length : product.length;
        width =
          additionalInfo?.length > 0 ? additionalInfo.width : product.width;
        height =
          additionalInfo?.length > 0 ? additionalInfo.height : product.height;
        dimensionUnit =
          additionalInfo?.length > 0
            ? additionalInfo.dimensionUnit
            : product.dimensionUnit;
        weight =
          additionalInfo?.length > 0 ? additionalInfo.weight : product.weight;
        weightUnit =
          additionalInfo?.length > 0
            ? additionalInfo.weightUnit
            : product.weightUnit;
      }

      let priceStr = '1';
      if (action.itemPriceFromUrl) {
        priceStr = action.itemPriceFromUrl + '';
      } else if (price) {
        priceStr = price + '';
      }
      let mfnShippingPriceStr = '0';
      if (action.shippingCostFromUrl) {
        mfnShippingPriceStr = action.shippingCostFromUrl + '';
      } else if (featuredOfferShipping) {
        mfnShippingPriceStr = featuredOfferShipping + '';
      }

      const queryProduct: QueryProductInfo = {
        asin: product.asin,
        merchantSku: product.merchantSku,
        fnsku: product.fnsku,
        glProductGroupName: product.gl,
        tRexId: product.tRexId,
        specialDeliveryRequirement: additionalInfo?.specialDeliveryRequirement,
        packageLength: length + '',
        packageWidth: width + '',
        packageHeight: height + '',
        dimensionUnit: dimensionUnit!,
        packageWeight: weight + '',
        weightUnit: weightUnit!,
        afnPriceStr: priceStr, // User can update them in program component
        mfnPriceStr: priceStr,
        mfnShippingPriceStr,
        currency: currency
          ? currency
          : getCurrencyUnitConfig(action.countryCode),
        isNewDefined: false,
      };

      yield put(setSelectedProductUpdate(action.countryCode, queryProduct));
    }

    yield put(getAdditionalInfoQuerySuccessAction(additionalInfoRes));
  } catch {
    yield put(getSelectedProductQueryFailedAction());
  }
}

export default function* selectedProductData() {
  yield takeLatest([SELECTED_PRODUCT_QUERY_START], getSelectedProductData);
}
